import React, { useEffect, useState } from 'react'
import { useTranslation } from '@app/lib/hooks/useTranslation'
import { Link } from '@app/components/stateless/typo/link'
import { Category } from './category'
import { JeffMendez } from '../svgs/jeff'
import { classNames } from '@app/utils/classes'
import { getDateLocale } from '@app/utils/date-locale'

interface JumboProps {
  backgroundImage?: string
  category: string
  cardTitle: string
  cardDescription: string
  authorName?: string
  href: string
  date: Date
  small?: boolean
  translation?: string
}

export const JumboCard = ({
  backgroundImage,
  category,
  cardDescription,
  cardTitle,
  authorName,
  href,
  date,
  small,
  translation,
}: JumboProps) => {
  const { t, lang } = useTranslation(translation ?? 'blog')

  const baseDate = date.toISOString()

  const [timeStamp, setTime] = useState<string>(baseDate)

  useEffect(() => {
    if (date) {
      setTime(
        getDateLocale(date, lang, {
          weekday: small ? undefined : 'long',
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        })
      )
    }
  }, [lang, date, setTime, small])

  const jumboTitle = t(cardTitle)

  const jumboID = `jumbo-${href.replaceAll('/', '-')}`

  return (
    <Link
      href={href}
      className={classNames(
        'w-full md:w-auto md:flex-1 bg-cover bg-center min-h-[17.5rem] relative block rounded hover:transform hover:-translate-y-1 border-2 dark:border-gray-700',
        backgroundImage ?? ''
      )}
      aria-labelledby={jumboID}
    >
      <article>
        <Category category={category} translation={translation} />
        <div
          className={`px-4 flex place-content-end flex-col absolute top-0 left-0 right-0 bottom-0 pt-14 bg-gradient-to-t from-black to-[#0000004d]`}
        >
          <div className='flex flex-col'>
            <h3
              className={classNames(
                'text-gray-100 font-bold',
                small ? 'text-lg md:text-xl' : 'text-2xl md:text-3xl'
              )}
              id={jumboID}
            >
              {jumboTitle}
            </h3>
            <div className='line-clamp-2 text-gray-200 dark:text-gray-300'>
              {t(cardDescription)}
            </div>
            <div className='text-white dark:text-gray-300 flex flex-1 place-items-center place-content-between py-3'>
              {authorName ? (
                <div className='flex space-x-2 place-items-center'>
                  <JeffMendez
                    className='bg-white rounded-3xl w-[26px] relative'
                    width={25}
                    height={25}
                  />
                  <div className='font-light text-sm'>{authorName}</div>
                </div>
              ) : null}
              <time className='font-semibold text-sm' dateTime={baseDate}>
                {timeStamp}
              </time>
            </div>
          </div>
        </div>
      </article>
    </Link>
  )
}
